<div class="se-side-report-history-container">
    @if (filteredEprEvents()?.length) {
    <div class="se-side-report-history-items-container">
        @for (item of filteredEprEvents(); track item.id) {
        <div class="items-inner-container">
            <se-side-report-history-item [item]="item"
                                         [expandedItemId]="expandedItemId"
                                         [isCp]="isAnyExaminationActive"
                                         (historySelectionChanged)="_onReportHistorySelectionChanged($event)">
            </se-side-report-history-item>
        </div>
        }
    </div>
    } @else {
    <div class="se-side-report-history-text-container">
        <span>{{ reportHistoryMessage }}</span>
    </div>
    }

    @if (isLoadingComputed() || (isLoading | async)) {
    <div class="estensa-spinner">
        <mat-spinner></mat-spinner>
    </div>
    }

    <!--Icone per info su warning/errori con tooltip esplicativo-->
    <div class="se-side-info-icons-container"
         [matTooltip]="reportHistoryTooltip"
         [matTooltipDisabled]="reportHistoryService.headerLoading()">

        @if (reportHistoryService.headerLoading()) {
        <div class="mini-spinner">
            <mat-spinner></mat-spinner>
        </div>
        }@else if(
        reportHistoryService.reportHistoryState() === 'INCOMPLETE' ||
        reportHistoryService.reportHistoryState() === 'ERROR'
        ) {
        <div class="error-icon">
            <mat-icon>error</mat-icon>
        </div>
        }@else if(
        reportHistoryService.reportHistoryState() === 'SUCCESS' ||
        reportHistoryService.reportHistoryState() === 'SUCCESS_NO_RESULT'
        ) {
        <div class="success-icon">
            <mat-icon>check</mat-icon>
        </div>
        }

    </div>

    <!--componente snackbar per info su warning/errori-->
    <se-side-snackbar />

</div>

<div class="se-side-report-filter-container">

    <mat-form-field appearance="outline" class="se-side-report-filter">
        @if(modalities().length || !filteredEprEvents()?.length) {
        <mat-label>
            {{'Modality' | translate}}
        </mat-label>
        }
        @else if (!modalities().length && filteredEprEvents()?.length) {
        <mat-label>
            <div class="mat-select-waiting-spinner-container">
                <mat-spinner class="spinner" diameter="16"></mat-spinner>
                <span style="margin-left: 5px">{{ "Loading" | translate }}</span>
            </div>
        </mat-label>
        }

        <mat-select multiple
                    (selectionChange)="_onFilterChange($event)"
                    [value]="reportHistoryService.selectedModalities()"
                    [placeholder]="'Modality' | translate"
                    [disabled]="!filteredEprEvents()?.length"
                    se-autofocus>
            @for (modality of modalities(); track $index) {
            <mat-option [value]="modality">
                {{ modality }}
            </mat-option>
            }
        </mat-select>
        <button (click)="_resetComboSelectedValue($event)"
                class="se-button-no-ripple"
                mat-icon-button
                type="button"
                tabIndex="-1"
                matSuffix>
            <mat-icon>close</mat-icon>
        </button>
    </mat-form-field>

</div>
